export const USERS_QUERY_KEY = ["users"];
export const PENDING_USERS_QUERY_KEY = ["pendingUsers"];
export const ROLES_QUERY_KEY = ["roles"];
export const USER_PROFILE_QUERY_KEY = ["auth", "profile"];
export const ADMIN_USER_STATS_QUERY_KEY = ["user_stats"];

export const BLOCKS_USER_QUERY_KEYS = {
  usersBase: ["blocksUsers"],
  users: (
    page: number,
    search: string,
    startDate?: string,
    endDate?: string,
  ) => ["blocksUsers", page, search, startDate, endDate],
  allUsers: (search?: string, startDate?: string, endDate?: string) => [
    "blocksUsers",
    "all",
    search,
    startDate,
    endDate,
  ],
  userById: (userId: string) => ["blocksUser", userId],
  usersByIds: (userIds: readonly string[]) => [
    "blocksUsers",
    "byIds",
    [...userIds].sort().join(","),
  ],
} as const;

export const USER_PROFILE_QUERY_KEYS = {
  base: ["userProfiles"],
  byUserId: (userId: string) => ["userProfiles", userId],
  groupIdsByUserId: (userId: string) => ["userProfiles", "groupIds", userId],
  archivedEventIds: (userId: string) => [
    "userProfiles",
    userId,
    "archivedEventIds",
  ],
} as const;
